var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isloading)?_c('div',{staticClass:"page__loading"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page__loading__box"},[_c('span',{staticClass:"page__loading__spinner"},[_c('i',{staticClass:"pi pi-spinner"})]),_c('span',{staticClass:"page__loading__label"},[_vm._v(" Loading... ")])])
}]

export { render, staticRenderFns }